var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14258 4L11.9997 6.85714",
    stroke: "#754FC5",
    strokeWidth: 1.37143,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 12.5712L2.28516 13.7141L3.42801 9.71407L10.5217 2.62036C10.968 2.17407 11.6914 2.17407 12.1377 2.62036L13.3789 3.8615C13.8252 4.30779 13.8252 5.03122 13.3789 5.4775L6.28516 12.5712Z",
    stroke: "#754FC5",
    strokeWidth: 1.37143,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen2);
export default __webpack_public_path__ + "static/media/Pen2.7e99e43ae3b9e84aae4b595ffce2e147.svg";
export { ForwardRef as ReactComponent };